<template>
  <div class="details-infos">
    <div class="title">{{ infos.name }}</div>
    <div class="time" v-show="infos.openingHours">
      <span>开放时间：</span>
      <span class="time-value">{{ infos.openingHours }}</span>
    </div>
    <div class="position">
      <div class="address">{{ infos.address }}</div>
      <div class="distance">距你{{ infos.distance }}km</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Infos',
  props: {
    infos: {
      type: Object,
      default: null
    }
  },
  components: {},
  data () {
    return {}
  },
  mounted () {
    // console.log("Infos data...", this.infos)
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.details-infos {
  background: #fff;
  width: 100%;
  height: auto;
  padding: 0.1rem 0 0 0.3rem;
  margin-bottom: 0.1rem;
  .title {
    width: 100%;
    vertical-align: middle;
    line-height: 0.5rem;
    font-size: 0.4rem;
    color: #333;
    margin-bottom: 0.2rem;
    font-weight: 500;
  }
  .time {
    width: 100%;
    height: 0.4rem;
    font-size: 0.28rem;
    color: #58a75d;
    margin-bottom: 0.1rem;
    .time-value {
      color: #333;
    }
  }
  .position {
    width: 100%;
    font-size: 0.28rem;
    color: #333;
    padding-top: 0.1rem;
    background: url(../../../../assets/images/bg_location.png) no-repeat right bottom;
    background-size: 1.7rem;
    .address {
      width: 75%;
      font-size: 0.28rem;
      color: #333333;
    }
    .distance {
      color: #666;
      font-size: 0.26rem;
      line-height: 0.38rem;
      padding-bottom: 0.2rem;
    }
  }
}
</style>
